export const GET_SQUARE_REQUESTS = 'GET_SQUARE_REQUESTS';
export const GET_SQUARE_REQUESTS_ERROR = 'GET_SQUARE_REQUESTS_ERROR';
export const GET_SQUARE_REQUESTS_SUCCESS = 'GET_SQUARE_REQUESTS_SUCCESS';